import script from "./TripPlanner.vue?vue&type=script&setup=true&lang=js"
export * from "./TripPlanner.vue?vue&type=script&setup=true&lang=js"

import "./TripPlanner.vue?vue&type=style&index=0&id=487bfdc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487bfdc6"]])

export default __exports__